// src/theme/createPalette.js
import { tokens } from "./tokens";

export function createPalette(mode = "dark") {
  const t = mode === "dark" ? tokens.dark : tokens.light;

  return {
    mode,

    primary: {
      main: tokens.accent.main,
      contrastText: mode === "dark" ? tokens.dark.bg : "#FFFFFF",
    },

    secondary: {
      main: mode === "dark" ? "rgba(255,255,255,0.82)" : "rgba(0,0,0,0.82)",
      contrastText: mode === "dark" ? tokens.dark.bg : "#FFFFFF",
    },

    background: {
      default: t.bg,
      paper: t.paper,
    },

    text: {
      primary: t.textPrimary,
      secondary: t.textSecondary,
      disabled: t.textDisabled,
    },

    divider: t.border,

    action: {
      hover: t.hover,
      selected: t.selected,
      disabled: mode === "dark" ? "rgba(255,255,255,0.30)" : "rgba(0,0,0,0.30)",
      disabledBackground: mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)",
      focus: tokens.accent.soft,
    },

    error: { main: mode === "dark" ? "#FF5A5F" : "#D32F2F" },
    warning: { main: mode === "dark" ? "#FFB020" : "#ED6C02" },
    info: { main: tokens.accent.main },
    success: { main: mode === "dark" ? "#4CD964" : "#2E7D32" },
  };
}
